<h2 mat-dialog-title>Informaci&oacute;n</h2>
<mat-dialog-content class="mat-typography">
  <div style="font-size: larger; line-height: 2.5">
    <div
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <span style="width: 180px"> Documento registrado: </span>

      <div
        style="
          display: flex;
          align-items: center;
          padding-left: 1rem;
          justify-content: space-between;
          flex: 1;
        "
      >
        <span class="info" style="padding-right: 1rem">
          {{ data.numeroDocumento }}
        </span>

        <button
          mat-icon-button
          matTooltip="Copiar"
          [cdkCopyToClipboard]="data.numeroDocumento"
          (click)="onClipboardCopy()"
        >
          <mat-icon> content_copy </mat-icon>
        </button>
      </div>
    </div>
    <div style="display: flex; align-items: center">
      <span style="width: 180px"> Con n&uacute;mero: </span>

      <div
        style="
          display: flex;
          align-items: center;
          padding-left: 1rem;
          justify-content: space-between;
          flex: 1;
        "
      >
        <span class="info" style="padding-right: 1rem">
          {{ data.numeroFlow }}
        </span>

        <button
          mat-icon-button
          matTooltip="Copiar"
          [cdkCopyToClipboard]="data.numeroFlow"
          (click)="onClipboardCopy()"
        >
          <mat-icon> content_copy </mat-icon>
        </button>
      </div>
    </div>
  </div>
  <p style="font-size: larger; line-height: 2.5"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>Aceptar</button>
</mat-dialog-actions>
